import React, {ReactNode} from "react";
import styled from "@emotion/styled";
import Colors from "../../styles/Colors";

interface Props {
    children: ReactNode,
    marginVertical?: number,
    marginHorizontal?: number,
    paddingVertical?: number,
    paddingHorizontal?: number,
    flexDirection?: "column" | "column-reverse" | "row" | "row-reverse",
}

const Section = ({
                     children,
                     marginVertical = 0,
                     marginHorizontal = 0,
                     paddingVertical = 0,
                     paddingHorizontal = 0,
                     flexDirection = "column"
                 }: Props) => {
    return (
        <SectionContainer
            marginVertical={marginVertical}
            marginHorizontal={marginHorizontal}
            paddingVertical={paddingVertical}
            paddingHorizontal={paddingHorizontal}
            flexDirection={flexDirection}
        >
            {children}
        </SectionContainer>
    )
}

export default Section

interface SectionProps {
    marginVertical: number,
    marginHorizontal: number,
    paddingVertical: number,
    paddingHorizontal: number,
    flexDirection: string,
}

const SectionContainer = styled.section<SectionProps>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${props => props.flexDirection};
  align-items: center;
  background-color: ${Colors.white};
  
  margin: ${props => props.marginVertical}px ${props => props.marginHorizontal}px;
  padding: ${props => props.paddingVertical}px ${props => props.paddingHorizontal}px;
  
  @media (max-width: 1024px) {
      flex-direction: column;
  }
`
